export const ADD_PIN_IMAGE = 'ADD_PIN_IMAGE';
export const ADD_PIN_IMAGE_SUCCESS = 'ADD_PIN_IMAGE_SUCCESS';
export const ADD_PIN_IMAGE_ERROR = 'ADD_PIN_IMAGE_ERROR';

export const ADD_PIN = 'ADD_PIN';
export const ADD_PIN_SUCCESS = 'ADD_PIN_SUCCESS';
export const ADD_PIN_ERROR = 'ADD_PIN_ERROR';

export const ADD_PINS = 'ADD_PINS';
export const ADD_PINS_SUCCESS = 'ADD_PINS_SUCCESS';
export const ADD_PINS_ERROR = 'ADD_PINS_ERROR';

export const GET_PINS = 'GET_PIN';
export const GET_PINS_SUCCESS = 'GET_PINS_SUCCESS';
export const GET_PINS_ERROR = 'GET_PINS_ERROR';

export const GET_PINS_FILTER = 'GET_PINS_FILTER';
export const GET_PINS_FILTER_SUCCESS = 'GET_PINS_FILTER_SUCCESS';
export const GET_PINS_FILTER_ERROR = 'GET_PINS_FILTER_ERROR';

export const UPDATE_PIN = 'UPDATE_PIN';
export const UPDATE_PIN_SUCCESS = 'UPDATE_PIN_SUCCESS';
export const UPDATE_PIN_ERROR = 'UPDATE_PIN_ERROR';

export const DELETE_PIN = 'DELETE_PIN';
export const DELETE_PIN_SUCCESS = 'DELETE_PIN_SUCCESS';
export const DELETE_PIN_ERROR = 'DELETE_PIN_ERROR';

export const REMOVE_PIN = 'REMOVE_PIN';
export const REMOVE_PIN_SUCCESS = 'REMOVE_PIN_SUCCESS';
export const REMOVE_PIN_ERROR = 'REMOVE_PIN_ERROR';

export const UPDATE_PIN_SCHEDULE = 'UPDATE_PIN_SCHEDULE';
export const UPDATE_PIN_SCHEDULE_SUCCESS = 'UPDATE_PIN_SCHEDULE_SUCCESS';
export const UPDATE_PIN_SCHEDULE_ERROR = 'UPDATE_PIN_SCHEDULE_ERROR';